import SanityTable from '../SanityTable.vue';
import Grid from '~/components/sanity/modules/Grid.vue';
import ContainerVue from '~/components/sanity/Container.vue';
import Tab from '~/components/sanity/Tab.vue';
import Tabs from '~/components/sanity/Tabs.vue';
export default {
  name: 'TabSection',
  components: {
    ContainerVue,
    Tab,
    Tabs,
    SanityTable,
    Grid
  },
  props: {
    header: String,
    tabs: Array,
    mobile: Object,
    styles: Object
  },
  computed: {
    style() {
      if (!this.styles) {
        return {
          color: '#000000',
          backgroundColor: '#FFFFFF'
        };
      }
      let style = {
        color: this.styles.color || '#FFFFFF'
      };
      if (this.styles.backgroundType === 'image') {
        style = {
          ...style,
          backgroundImage: `url(${this.styles.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      } else if (this.styles.backgroundType === 'color') {
        style.backgroundColor = this.styles.backgroundColor;
      } else {
        style.backgroundColor = '#000000';
      }
      return style;
    }
  }
};